export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAHklEQVR42mNgYGD4TyFm+P//P3l41IBRA6hrACUYAGX41jiavdrVAAAAAElFTkSuQmCC"